import { GetLoanableAmountsStateParam } from '@/models/request/loanableAmounts';
import actions from '@/state/modules/loanableAmounts/actions';

const getLoanableAmounts = (params: GetLoanableAmountsStateParam) => actions.getLoanableAmounts.request({ params });

export default {
  getLoanableAmounts,
};
